import {create} from 'jss';
import preset from 'jss-preset-default';
import rtl from 'jss-rtl';
import isRTL from './v2/utils/isRTL';

function getJSS() {
  const presets = preset().plugins;
  return create({plugins: [...presets, rtl({enabled: isRTL()})]});
}

export default getJSS;
